module.exports = __webpack_public_path__ + "static/media/ionicons.05acfdb5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/ionicons.woff?v=2.0.0
// module id = 1838
// module chunks = 0